import { createFileRoute } from '@tanstack/react-router'

import { BackofficeNewSubscriptionPage } from '../../../../components/pages/backoffice/common/backoffice-new-subscription-page.tsx'
import { PermissionChecker } from '../../../../components/templates/permission-checker.tsx'

export const Route = createFileRoute('/bo/subscriptions/new')({
  component: () => (
    <PermissionChecker requiredPermissions={['subscription.create']}>
      <BackofficeNewSubscriptionPage />
    </PermissionChecker>
  ),
})
